import React from 'react';
import type { TransitRoutePayload } from '../../../data-access/api/science/openapi/api';
import './richContext.scss';

type Props = {
  p: TransitRoutePayload;
};

const TransitRouteContent: React.FC<Props> = ({ p }) => {
  return (
    <div className="rc-content-body">
      <div className="rc-transit-row">
        <span className="rc-transit-station">{p.origin}</span>
        <span className="rc-transit-arrow">→</span>
        <span className="rc-transit-station">{p.destination}</span>
      </div>
      {!!p.depart_by && <span className="rc-content-meta">Depart by {p.depart_by}</span>}
    </div>
  );
};

export default TransitRouteContent;
